import React, {useEffect, useState} from "react";
import { DeveloperGetSearchResponse, DeveloperInfo } from "../../../shared/types/developer";
import "./developer-list.scss"
import {Filters} from "../../../shared/types/filters";
import {SERVER_URL, DEVELOPER_API_PATH} from "../../../../global_vars";
import axios from "axios";
import DeveloperPreview from "../developer-preview/developer-preview";

function DeveloperList() {

    const [state, setState] = useState<DeveloperInfo[]>([]);

    const [filters, setFilters] = useState<Filters>({
        name: "",
        page: 1,
        page_size: 100
    });

    useEffect(() => {
        getDeveloperList(filters);
    }, [filters])

    const getDeveloperList = (filters: Filters) => {
        axios.get<DeveloperGetSearchResponse>(`${SERVER_URL}${DEVELOPER_API_PATH}/search`, {
            params: {
                ...filters
            }
        }).then((resp) => {
            return resp.data;
        }).then((data) => {
            var developerInfo = data.data;
            setState(developerInfo);
        }).catch((error) => {
            console.log("Error: ", error);
        })
    };

    return (
        <div style={{paddingTop: "56px"}}>
            <div className="developer-list-header">
                <h2>MEET OUR DEVELOPERS</h2>
                <div className="content">
                    At Luxora Dubai, we collaborate with the most prestigious and
                    visionary real estate developers to bring you world-class properties that redefine luxury living.
                    Our partners are known for their innovation, architectural excellence, and
                    commitment to crafting extraordinary communities.
                    Explore our curated selection of esteemed developers and discover stunning residences designed for the elite.
                    Whether you seek waterfront elegance, urban sophistication, or
                    serene landscapes, Luxora connects you with the best in Dubai's real estate market.
                </div>
            </div>
            <div className="developer-list">
                {state.map((developer, index) => (
                    <DeveloperPreview key={index} id={developer.id} name={developer.name}
                                      description={developer.description} logo_url={developer.logo_url}></DeveloperPreview>
                ))}
            </div>
        </div>
    );
}

export default DeveloperList;